import React, { useMemo, useState } from "react";
import { Prospects } from "../../pages";
import { BusinessController } from "../../controllers";

const ProspectsContainer = () => {
  const [limit, setLimit] = useState(50);
  const [filterQuery, setFilterQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [addProspectModal, setAddProspectModal] = useState(false);
  const [addBulkProspectModal, setAddBulkProspectModal] = useState(false);

  const prospectsTableQuery = useMemo(() => {
    return `offset=${currentPage + 1}&limit=${limit}`;
  }, [currentPage, limit]);

  const { isLoading, data, isFetching } = BusinessController.useGetProspects(
    prospectsTableQuery,
    filterQuery,
    searchQuery
  );

  const onLimitChange = (limit) => {
    setLimit(limit);
    setCurrentPage(0);
  };

  const goToAddProspect = () => {
    setAddProspectModal(true);
  };
  const goToAddBulkProspect = () => {
    setAddBulkProspectModal(true);
  };
  const closeModal = () => {
    setAddProspectModal(false);
    setAddBulkProspectModal(false);
  };

  return (
    <Prospects
      onLimitChange={onLimitChange}
      data={data}
      currentPage={currentPage}
      setCurrentPage={setCurrentPage}
      limit={limit}
      isLoading={isLoading}
      isFetching={isFetching}
      setSearchQuery={setSearchQuery}
      addProspectModal={addProspectModal}
      goToAddProspect={goToAddProspect}
      goToAddBulkProspect={goToAddBulkProspect}
      addBulkProspectModal={addBulkProspectModal}
      closeModal={closeModal}
    />
  );
};

export default ProspectsContainer;
